window.startPlay = function (configs, settings) {
    var wrap = configs.wrap,
        id = configs.id,
        type = configs.type,
        urls = configs.urls,
        width = configs.width || 920,
        height = configs.height || 534;

    var html = "";
    if (type === "video") {
        html +=
            '<div id="' +
            id +
            '" style="width: ' +
            width +
            "px; height: " +
            height +
            'px;"><video></video></div>';
    } else {
        height = configs.height || 50;
        html +=
            '<div id="' +
            id +
            '" style="width: ' +
            width +
            "px; height: " +
            height +
            'px;"><audio></audio></div>';
    }
    wrap.html(html);

    settings = settings || {};
    if (settings.autoplay === undefined) settings.autoplay = true;
    if (settings.controls === undefined) settings.controls = true;
    if (settings.sources === undefined) settings.sources = mapSources(urls);
    if (settings.width === undefined) settings.width = width;
    if (settings.height === undefined) settings.height = height;

    var player = new DsPlayer("#" + id + " " + type, settings);

    return player;
};

function mapSources(urls) {
    var sources = [];
    for (var i = 0; i < urls.length; i++) {
        sources.push({
            src: urls[i],
        });
    }
    return sources;
}
